import _ from 'lodash';
import * as type from './types';
export default (state = [], action) => {
  switch (action.type) {
    case type.FETCH_PRODUCTS:
      return { ..._.mapKeys(action.payload, 'id') };
    case type.FETCH_PRODUCT:
      return { ...state, [action.payload.id]: action.payload };
    case type.CREATE_PRODUCT:
      return { ...state, [action.payload.id]: action.payload };
    case type.EDIT_PRODUCT:
      return { ...state, [action.payload.id]: action.payload };
    case type.DELETE_PRODUCT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
